<!-- info-page.component.html -->
<div class="container mx-auto p-6">
  <a routerLink="/participants" class="text-blue-600 hover:text-blue-800"
    >&larr; Participant</a
  >

  <div class="bg-white shadow rounded-lg p-6 mt-6" *ngIf="headerData">
    <h2 class="text-2xl font-semibold mb-4">Participant info</h2>
    <div class="flex items-center mb-4">
      <div class="icon-container mr-4">
        <ng-container *ngIf="headerData.pictureUrl; else elseBlock">
          <img
            src="{{ headerData.pictureUrl }}"
            alt="Participant"
            class="w-10 h-10 rounded-full"
          />
        </ng-container>
        <ng-template #elseBlock>
          <mat-icon>person</mat-icon>
        </ng-template>
      </div>
      <div>
        <div class="font-medium text-lg">{{ headerData.name }}</div>
        <p>Email: {{ headerData.email }}</p>
        <p>Phone number: {{ headerData.phoneNumber }}</p>
        <p>Line display name: {{ headerData.lineName }}</p>
      </div>
    </div>
    <!-- <div class="border-t pt-4">
      <div class="text-gray-600">
        Total Spending: {{ headerData.amount }} THB
      </div>
      <div class="text-sm text-gray-500">
        (Spending that has been confirmed)
      </div>
    </div> -->
  </div>

  <!-- <div class="bg-white shadow rounded-lg p-6 mt-6">
    <h2 class="text-2xl font-semibold mb-4">Spending request</h2>
    <div class="overflow-x-auto">
      <table class="min-w-full">
        <thead>
          <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-4">Request ID</th>
            <th class="px-6 pt-6 pb-4">Date register</th>
            <th class="px-6 pt-6 pb-4">Spending amount</th>
            <th class="px-6 pt-6 pb-4">Card no.</th>
            <th class="px-6 pt-6 pb-4">Status</th>
            <th class="px-6 pt-6 pb-4">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr class="hover:bg-gray-100" *ngFor="let item of totalData">
            <td class="px-6 py-4">{{ item._id | slice : 15 }}</td>
            <td class="px-6 py-4">{{ item.createdAt }}</td>
            <td class="px-6 py-4">{{ item.amount }}</td>
            <td class="px-6 py-4">{{ item.card }}</td>
            <td class="px-6 py-4">{{ item.status }}</td>
            <td class="px-6 py-4">
              <a
                routerLink="/receipt-info/{{ item._id }}"
                class="text-blue-600 hover:text-blue-800"
                >View info</a
              >
            </td>
          </tr>
     
        </tbody>
      </table>
    </div>
  </div> -->
  <div class="bg-white shadow rounded-lg p-6 mt-6">
    <h2 class="text-2xl font-semibold mb-4">Images</h2>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div
        class="bg-white shadow rounded-lg p-3 w-full h-full"
        *ngFor="let image of images"
      >
        <div class="flex justify-between items-center cursor-pointer">
          <h3 class="text-lg font-medium mb-4">
            {{ (image.createdAt | date : "dd/MM/yyyy") || "No date" }}
          </h3>
          <button mat-icon-button (click)="viewImage(image.url)">
            <mat-icon>visibility</mat-icon>
          </button>
        </div>

        <div class="max-h-[300px] min-h-[300px] overflow-y-auto">
          <div class="w-full h-full flex justify-center items-center">
            <img
              src="{{ image.url }}"
              alt="Image"
              class="rounded-lg object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
